module.exports = __webpack_public_path__ + "img/google-reviews.f48195ca.png";